<template>
  <div class="LKProfilePersonalData">
    <h3 class="LKProfilePersonalData__title">
      Личные данные
    </h3>

    <hr class="LKProfilePersonalData__line">

    <v-row>
      <template v-for="(item, index) in profileFields">
        <v-col :key="index" cols="6">
          <BTextarea
            :value="item.value"
            :label="item.label"
            :rows="1"
            rounded
            disabled
          />
        </v-col>
      </template>
    </v-row>

    <hr class="LKProfilePersonalData__line">

    <v-row>
      <v-col cols="4">
        <LKProfileAvatar
          :image-url="profile.photo"
          :full-name="profile.full_name"
          :image-uploading="isImageUploading"
          @change="onChangeAvatar"
        />
      </v-col>
      <template v-for="(item, index) in contactFields">
        <v-col :key="index" cols="4">
          <BTextarea
            :value="item.value"
            :label="item.label"
            :rows="1"
            :validate="item.validate"
            rounded
            @change="v => onChangeContactsDebounced(item.key, v)"
          />
        </v-col>
      </template>
    </v-row>

    <template v-if="profile.is_superuser">
      <h3 class="LKProfilePersonalData__title">
        Права доступа
      </h3>

      <hr class="LKProfilePersonalData__line">

      <BTableCommon
        type="profile-permissions"
        :list="permissions"
      />

      <h3 class="LKProfilePersonalData__title">
        Действия
      </h3>

      <hr class="LKProfilePersonalData__line">

      <slot name="actions" />
    </template>
  </div>
</template>

<script>
import { LKProfileMapper } from '../store'
import debounce from 'lodash/debounce'
import { DEBOUNCE_TIMEOUT } from '@/helpers/enums/params'

import BTextarea from '@/components/forms/BTextarea.vue'
import BTableCommon from '@/components/tables/BTableCommon.vue'
import LKProfileAvatar from './LKProfileAvatar.vue'


export default {
  name: 'LKProfilePersonalData',
  inject: ['$validator'],
  components: {
    BTextarea,
    BTableCommon,
    LKProfileAvatar,
  },
  inheritAttrs: false,
  props: {
    profile: {
      type: Object,
      required: true,
    },
    info: {
      type: Object,
      required: true,
    },
    permissions: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    isImageUploading: false,
  }),
  computed: {
    profileFields() {
      const { profile } = this

      return [
        {
          label: 'Логин',
          value: profile.username,
        },
        {
          label: 'ФИО',
          value: profile.full_name,
        },
      ]
    },
    contactFields() {
      const { profile } = this

      return [
        {
          label: 'E-mail',
          key: 'email',
          validate: 'email',
          value: profile.email,
        },
        {
          label: 'Телефон',
          key: 'phone',
          validate: null,
          value: profile.phone,
        },
      ]
    },
  },
  created() {
    this.onChangeContactsDebounced = debounce(
      this.onChangeContacts,
      DEBOUNCE_TIMEOUT,
    )
  },
  methods: {
    ...LKProfileMapper.mapActions([
      'updateCurrentContacts',
    ]),

    async onChangeAvatar(photo) {
      this.isImageUploading = true
      try {
        await this.updateCurrentContacts({ payload: { photo } })
        this.$emit('change')
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        this.isImageUploading = false
      }
    },

    async onChangeContacts(key, value) {
      if (this.$validator.errors.items.length > 0) return
      try {
        await this.updateCurrentContacts({ payload: { [key]: value } })
        this.$notice.create({ text: 'Данные обновлены' })
      } catch (e) {
        this.$notice.errors(e)
      }
    },
  },
}
</script>

<style lang="scss">
.LKProfilePersonalData {
  & &__title {
    margin-top: 30px;
    font-size: 22px;
  }

  &__line {
    height: 1px;
    margin: 22px 0 30px 0;
    color: $webflow-color-alert-line;
    background-color: $webflow-color-alert-line;
    border: 0;
  }
}
</style>
